// @flow

import * as React from "react";
import { Popper as Pop } from "react-popper";
import Transition from "react-transition-group/Transition";

import styles from "./Popper.scss";

const transitionStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 1 }
};

type PopperProps = {
  isOpen: boolean,
  popperRef: {
    current: null | HTMLDivElement
  },
  content: () => React.Node
};

const Popper = ({ isOpen, popperRef, content }: PopperProps) => (
  <Transition in={isOpen} timeout={150} unmountOnExit>
    {state => (
      <Pop
        placement="right-start"
        placements={["right-start", "left-start"]}
        modifiers={{ preventOverflow: { priority: ["right", "left"] } }}
      >
        {({ ref, style, placement }) => (
          <div ref={popperRef}>
            <div
              className={styles.popper}
              style={{
                ...transitionStyles[state],
                ...style
              }}
              ref={ref}
              data-placement={placement}
            >
              {content()}
              <div className={styles.bridge} />
            </div>
          </div>
        )}
      </Pop>
    )}
  </Transition>
);

export default Popper;
